import axios from 'axios'
export default {
      //微信分享方法
  ShareLocal: function(title, desc, imgurl, link, callback) {
    var url = window.location.href;
    if (url.indexOf("#") > -1) {
      url = url.split("#")[0];
    }
    var sharetitle = title || document.title;
    var sharelink = link || window.location.href;
    var sharedesc = desc || document.title;
    var shareimgUrl = imgurl || "https://luohuapp.sznews.com/jhxtapi/Public/title_left.jpg?v=20191107";
    axios({
      url:
        "https://v2.sznews.com/weitest/index.php?s=Wxshare/getwx.html&url=" +
        url.replace(/&/g, "@"),
      method: "post",
      // withCredentials: true,
    }).then(res => {
        console.log(res);
        
        var wx = window.wx
        var msg = res.data
        wx.config({
          debug: false, //值为true时进入debug模式，可以打出状态值
          appId: msg.appId,
          timestamp: msg.timestamp,
          nonceStr: msg.nonceStr,
          signature: msg.signature,
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            // 所有要调用的 API 都要加到这个列表中
          ],
        });
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function() {
              // 以键值对的形式返回，可用的api值true，不可用为false              
            },
          });

          wx.error(function() {});
          //获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
          wx.onMenuShareTimeline({
            title: sharetitle, // 分享标题
            link: sharelink, // 分享链接
            imgUrl: shareimgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
              if (typeof callback === "function") {
                //是函数
                callback();
              }
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
            fail: function() {
              //alert("share1 fail");
            },
          });
          //获取“分享给朋友”按钮点击状态及自定义分享内容接口
          wx.onMenuShareAppMessage({
            title: sharetitle, // 分享标题
            desc: sharedesc, // 分享描述
            link: sharelink, // 分享链接
            imgUrl: shareimgUrl, // 分享图标
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function() {
              // 用户确认分享后执行的回调函数
              if (typeof callback === "function") {
                //是函数
                callback();
              }
              // console.log("share2 success");
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
            fail: function() {
              //alert("share2 fail");
            },
          });
          //获取“分享到QQ”按钮点击状态及自定义分享内容接口
          wx.onMenuShareQQ({
            title: sharetitle, // 分享标题
            desc: sharedesc, // 分享描述
            link: sharelink, // 分享链接
            imgUrl: shareimgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
              if (typeof callback === "function") {
                //是函数
                callback();
              }
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
          });
          //获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
          wx.onMenuShareWeibo({
            title: sharetitle, // 分享标题
            desc: sharedesc, // 分享描述
            link: sharelink, // 分享链接
            imgUrl: shareimgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
              if (typeof callback === "function") {
                //是函数
                callback();
              }
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
          });
          //获取“分享到QQ空间”按钮点击状态及自定义分享内容接口
          wx.onMenuShareQZone({
            title: sharetitle, // 分享标题
            desc: sharedesc, // 分享描述
            link: sharelink, // 分享链接
            imgUrl: shareimgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
              if (typeof callback === "function") {
                //是函数
                callback();
              }
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
          });
        });
    })


  }
}
